const mutations = {
    SET_MODAL_DATA(state, data) {
        state.modalData = data;
    },
    SET_SELECTED_ADDRESS_ID(state, id) {
        state.selectedAddressId = id;
    },
    SET_ADDRESSES(state, response) {
        const pickupAddresses = Object.values(response.data.addresses).filter(
            (address) => address.isStorePickup
        );
        const courierAddresses = Object.values(response.data.addresses).filter(
            (address) => !address.isStorePickup
        );

        state.pickupAddresses = pickupAddresses;
        state.courierAddresses = courierAddresses;
        state.isInitialAddressesFetch = false;
    },

    SET_SELECTED_DATE_ID(state, id) {
        state.selectedDateId = id;
    },
    SET_DATES(state, response) {
        state.dates = Object.values(response.data.dates);
        state.isInitialDatesFetch = false;
    },

    SET_SELECTED_TIME_ID(state, id) {
        state.selectedTimeId = id;
    },
    SET_TIMES(state, response) {
        state.times = Object.values(response.data.times);
        state.isInitialTimesFetch = false;
    },

    DISABLE_ADDRESSES(state) {
        state.isAddressesDisabled = true;
    },
    ENABLE_ADDRESSES(state) {
        state.isAddressesDisabled = false;
    },

    DISABLE_DATES(state) {
        state.isDatesDisabled = true;
        state.selectedDateId = null;
    },
    ENABLE_DATES(state) {
        state.isDatesDisabled = false;
    },

    DISABLE_TIMES(state) {
        state.isTimesDisabled = true;
        state.selectedTimeId = null;
    },
    ENABLE_TIMES(state) {
        state.isTimesDisabled = false;
    },

    SHOW_ALL_ADDRESSES(state) {
        state.isAllAddressesShown = true;
    },
    HIDE_ALL_ADDRESSES(state) {
        state.isAllAddressesShown = false;
    },

    CHANGE_ADDRESSES_VISIBILITY(state) {
        state.isAllAddressesShown = !state.isAllAddressesShown;
    },

    SET_DATES_ERROR_MESSAGE(state, message) {
        state.datesErrorMessage = message;
    },

    SET_SHOP_TYPE(state, type) {
        state.shopType = type;
    },

    SET_EMPTY_CART(state, newState) {
        state.isEmptyCart = newState;
    },

    SET_ACTIVE_ADDRESSES_TAB(state, tab) {
        state.activeAddressesTab = tab;
    },

    SET_AUTOCOMPLETE_VALUE(state, value) {
        state.autocompleteValue = value;
    },

    SET_AUTOCOMPLETE_ADDRESS(state, { postCode, city, street, fullAddress }) {
        state.autocompletePostCode = postCode;
        state.autocompleteCity = city;
        state.autocompleteStreet = street;
        state.autocompleteValue = fullAddress;
    },

    SET_PROCESS_ERROR_MESSAGE(state, message) {
        state.processErrorMessage = message;
    },

    SET_HEADER_TITLE(state, title) {
        state.headerTitle = title;
    },

    SET_WANNA_CHANGE_ADDRESS(state, value) {
        state.wannaChangeAddress = value;
    },

    SET_AUTOCOMPLETE_ADDRESS_IS_USED(state, value) {
        state.autocompleteAddressIsUsed = value;
    },

    SET_SWITCH_IS_SUBMITTING(state, value) {
        state.switchIsSubmitting = value;
    },

    SET_MAIN_COMPONENT(state, component) {
        state.mainComponent = component;

        if (component === "MainSwitch") {
            state.newAddressData.name = "";
            state.newAddressData.company = "";
            state.newAddressData.address = "";
            state.newAddressData.city = "";
            state.newAddressData.postCode = "";
            state.newAddressData.phone = "";
            state.newAddressData.countryId = 1;
        }
    },

    SET_NEW_ADDRESS_CHECKED(state, value) {
        state.newAddressChecked = value;
    },

    SET_NEW_ADDRESS_DATA(state, data) {
        state.newAddressData.city = data.city;
        state.newAddressData.postCode = data.post_code;
        state.newAddressData.address = data.address;
        state.newAddressData.countryId = data.country_id;
    },

    SET_ADDRESS_IS_SUBMITTING(state, value) {
        state.addressIsSubmitting = value;
    },

    SET_AVAILABLE_COUNTRIES(state, countries) {
        state.availableCountries = countries;
    },
};

export default mutations;
